import { DrawerHeader } from '@datanomik/commons-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { SupportPanelReportProblemChannelsArea } from './support-panel-report-problem-areas/SupportPanelReportProblemChannelsArea';

type SupportPanelReportProblemProps = {
  onBack: () => void;
};
export function SupportPanelReportProblem({ onBack }: SupportPanelReportProblemProps) {
  const { t } = useTranslation();
  return (
    <>
      <DrawerHeader
        startAdornment={(
          <ArrowBack
            onClick={onBack}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateX(-4px)',
              },
            }}
          />
        )}
        text={t('Report a problem')}
      />
      <SupportPanelReportProblemChannelsArea />

    </>
  );
}
